// src/components/resources/GlobalResources.tsx
import React from 'react';
import ResourceButtons from './ResourceButtons';

interface GlobalResourcesProps {
  children: React.ReactNode;
}

const GlobalResources: React.FC<GlobalResourcesProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {children}
      
      {/* Fixed Floating Buttons - Top Center */}
      <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-40">
        <ResourceButtons />
      </div>
    </div>
  );
};

export default GlobalResources;